import { AskAicaPrompts } from './AskAicaOrb.types';

export const DEFAULT_LABEL = 'Ask AICA';
export const HOVER_LABEL = 'Start a conversation'; // replaces "Ask AICA" on hover, once settled

/** Portfolio level — no single company in view. */
export const PORTFOLIO_PROMPTS: AskAicaPrompts = ['Ask anything about your portfolio...', 'Which companies need attention?'];

// Sequence timings. Kept in step with the durations declared in
// AskAicaOrb.module.scss and asserted by AskAicaOrb.test.tsx's parity check.
export const READY_SETTLE_MS = 400; // small buffer after `ready` flips true — softens the reflow/paint burst that lands right when the real data arrives.
export const ORB_HOLD_MS = 700; // orb sits alone briefly before the question pill starts growing out.
export const EXPAND_MS = 600; // question pill sliding out from behind the orb.
export const REVEAL_MS = 900; // the first text's blur sweep (.LabelReveal).
export const HOLD_MS = 1000; // first text fully visible.
export const SWAP_OUT_MS = 300; // first text receding before the second arrives (.LabelRecede).
export const SECOND_MS = 2200; // second text: 1.2s shimmer (.LabelShimmer) + ~1s fully visible.
export const CLOSE_MS = 600; // quick slide back behind the orb.
export const IDLE_HOLD_MS = 300; // brief pause fully hidden behind the orb before "Ask AICA" appears.
export const SHORT_ORB_HOLD_MS = 400; // short mode: orb alone briefly before "Ask AICA" grows out.
export const IDLE_EXPAND_MS = 550; // "Ask AICA" pill growing out around the orb.
